import $ from "jquery";

$("[data-video-hover]").on("mouseover", function () {
    let video = $(this).find("video");

    if (video.length > 0) {
        video.get(0).play();
    }
});
$("[data-video-hover]").on("mouseout", function () {
    let video = $(this).find("video");

    if (video.length > 0) {
        video.get(0).pause();
    }
});
